var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from "react";
import { useMutation, useQuery } from "react-query";
import { encodeJwt, getConfig } from "@jti/fe-common";
import { DeviceApi } from "../../services";
import { getUser } from "../../utils";
const initDeviceApi = (user) => {
    const config = getConfig();
    const { first_name, last_name, magento_token, unique_id, uuid, email, ciam_token } = user;
    const token = encodeJwt({
        unique_id,
        first_name,
        last_name,
        email,
        ciam_token,
        magento_token,
        uuid,
        tenant_code: config.CAS_X_DES_AK_TENANT_TOKEN,
        ciam_tenant_token: config.CAS_X_DES_AK_TENANT_TOKEN,
    });
    const deviceAPI = DeviceApi.init(token);
    return deviceAPI;
};
export const DEVICE_REGISTERED_CODE = 202;
export const deviceErrorCodes = {
    400: "profiles.devices.notification.bad_request_title",
    401: "profiles.devices.notification.unauthorized_user_title",
    406: "profiles.devices.notification.invalid_registration_code_title",
    409: "profiles.devices.notification.registered_already_another_user_title",
    500: "profiles.devices.notification.processing_error_title",
};
export const deviceErrorActions = {
    400: "profiles.devices.notification.action.try_later",
    401: "profiles.devices.notification.action.try_later",
    500: "profiles.devices.notification.action.try_later",
};
const queryKey = "devicesKey";
export const useDevices = () => {
    const user = getUser();
    const deviceAPI = initDeviceApi(user);
    const { uuid } = user;
    const { data, isLoading, isError, refetch } = useQuery(queryKey, () => deviceAPI.myDevices(uuid), {
        enabled: Boolean(uuid),
    });
    const deleteMutation = useMutation(queryKey, ({ id, consumerId }) => deviceAPI.deleteDevice(id, consumerId));
    const registerMutation = useMutation("devicesKey", (registrationCode) => deviceAPI.registerDevice(registrationCode, uuid));
    const deleteDevice = useCallback((id) => __awaiter(void 0, void 0, void 0, function* () {
        if (uuid === undefined) {
            return Promise.reject("Consumer ID is not defined");
        }
        return yield deleteMutation.mutateAsync({ id, consumerId: uuid });
    }), [deleteMutation]);
    return {
        data,
        isLoadingData: isLoading,
        isErrorData: isError,
        deleteDevice,
        registerDevice: registerMutation.mutateAsync,
        resetRegisterDevice: registerMutation.reset,
        isRegisterDeviceError: registerMutation.isError,
        isLoadingRegisterDevice: registerMutation.isLoading,
        registerDeviceError: registerMutation.error,
        refetch,
    };
};
//# sourceMappingURL=useDevices.js.map